'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const universal_color = require('../../style/universal.color.js');

// Types used for Styling the text input
var TextInputTypes = /*#__PURE__*/function (TextInputTypes) {
  TextInputTypes["PRIMARY"] = "primary";
  TextInputTypes["DARK"] = "dark";
  return TextInputTypes;
}({});
var TextInputColors = {
  primary: {
    base: universal_color.mlbWhite,
    border: universal_color.mlbGrey6,
    text: universal_color.mlbGrey3,
    icon: universal_color.mlbGrey6
  },
  dark: {
    base: universal_color.mlbGrey6,
    border: universal_color.mlbGrey6,
    text: universal_color.mlbGrey3,
    icon: universal_color.mlbWhite
  }
};
var TextInputShapes = /*#__PURE__*/function (TextInputShapes) {
  TextInputShapes["DEFAULT"] = "default";
  TextInputShapes["PILL"] = "pill";
  return TextInputShapes;
}({});
var BorderRadius = /*#__PURE__*/function (BorderRadius) {
  BorderRadius["DEFAULT"] = "5px";
  BorderRadius["FULL"] = "9999px";
  return BorderRadius;
}({});

exports.BorderRadius = BorderRadius;
exports.TextInputColors = TextInputColors;
exports.TextInputShapes = TextInputShapes;
exports.TextInputTypes = TextInputTypes;
